import * as styles from "./ContactPreview.css";

import { useSyncExternalStore } from "react";

import {
  Popover,
  PopoverContent,
  PopoverViewport,
} from "@frontend/components/atoms/Popover";
import {
  ScrollArea,
  ScrollAreaContent,
  ScrollAreaScrollbar,
  ScrollAreaThumb,
  ScrollAreaViewport,
} from "@frontend/components/atoms/ScrollArea";
import { Trans } from "@lingui/react/macro";

import { ContactPreview } from "./ContactPreview";
import {
  closeContact,
  contactPreviewHandle,
  getGroup,
  subscribeGroup,
} from "./contactPreviewGroup";

// The page's single contact card. Every trigger points at it through
// `contactPreviewHandle`, so moving from one person to the next slides the same
// popup instead of swapping two.

export function ContactPreviewHost() {
  const group = useSyncExternalStore(subscribeGroup, getGroup);

  return (
    <Popover
      handle={contactPreviewHandle}
      open={group.open}
      triggerId={group.target?.triggerId ?? null}
      onOpenChange={(next) => {
        if (!next) {
          closeContact();
        }
      }}
    >
      <PopoverContent side={group.target?.side ?? "left"}>
        <PopoverViewport>
          {group.shown?.status === "loaded" ? (
            <ScrollArea className={styles.scrollArea}>
              <ScrollAreaViewport fade>
                <ScrollAreaContent>
                  <ContactPreview contact={group.shown.contact} />
                </ScrollAreaContent>
              </ScrollAreaViewport>

              <ScrollAreaScrollbar expandOnHover>
                <ScrollAreaThumb />
              </ScrollAreaScrollbar>
            </ScrollArea>
          ) : (
            <div className={styles.state}>
              <Trans>This contact could not be loaded.</Trans>
            </div>
          )}
        </PopoverViewport>
      </PopoverContent>
    </Popover>
  );
}
